export type SeriesItem = {
  key: string;
  name: string;
  color: string;
};

export type ChartDataItem = {
  [key: string]: string | number;
  day: string;
};

export const buildBarChartExportData = (series: SeriesItem[], data: ChartDataItem[], valueScale = 1) => {
  return data.map((row) => {
    const rawDate = String(row.day);
    const parts = rawDate.match(/\d+/g) || [];
    const formattedDate =
      parts.length >= 3 ? `${parts[0]}/${parts[1].padStart(2, '0')}/${parts[2].padStart(2, '0')}` : rawDate;
    const out: Record<string, string | number> = { 日付: `\t${formattedDate}` };
    series.forEach((s) => {
      const raw = row[s.key];
      const num = typeof raw === 'number' ? raw * valueScale : Number(raw) || 0;
      out[s.name] = Math.round(num * 100) / 100;
    });
    return out;
  });
};
